import { useEffect } from 'react';

const useKeyDown = (
  targetKey: string,
  callback: () => void,
): void => {
  useEffect(() => {
    const onKeyDown = ({ key }: KeyboardEvent) => {
      if (key === targetKey) {
        callback();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [callback, targetKey]);
};

export default useKeyDown;
